import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { Action } from 'rxjs/internal/scheduler/Action';

@Injectable({
  providedIn: 'root',
})
export class mySchoolsService {
  public schoolProps!: SchoolData;

  constructor(private httpClient: HttpClient, private apiUrl: AppConfig) {}

  public mySchoolsAPI = (data: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherMySchoolsApiURL.mySchoolsAPI,
      { params: data }
    );
  };
  public appearAvailableAPI = (data: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherMySchoolsApiURL.appearAvailableAPI,
      { params: data }
    );
  };

  public setPreferencesAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherMySchoolsApiURL.setPreferencesAPI,
      data
    );
  }
}
